import Settings from './settings';
import { Row, Col } from 'antd';
const CompanySettings = () => {
  return (
    <div className="nav-page-content">
      <Row gutter={24}>
        <Col span={24}>
          <Settings />
        </Col>
      </Row>
    </div>
  );
};

export default CompanySettings;
